<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogWashFormVisible = true" :disabled="!power.coupon_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.coupon_del">删除</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel">导出Excel</el-button>
            </el-col>

            <!-- search start  -->
            <!-- <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.searchText" size="small" placeholder="请输入textContent" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col> -->
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="coupon_no" label="编号" width="180"></el-table-column>
                    <el-table-column prop="password" label="密码" width="180"></el-table-column>

                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.coupon_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.coupon_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog title="生成洗车券" :visible.sync="dialogWashFormVisible" :close-on-click-modal="false" @close="dialogClose" width="450px" center>
            <el-form :model="washform" ref="washform" class="dialog-form" @submit.native.prevent>
                <el-form-item label="洗车券数量"
                    :label-width="formLabelWidth"
                    prop="num"
                    :rules="[
                    { required: true, message: '洗车券数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="washform.num" autocomplete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogWashFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addCarWash('washform')">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="750px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="编号"
                    :label-width="formLabelWidth"
                    prop="coupon_no"
                    :rules="[
                    { required: true, message: '请输入洗车券编号', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.coupon_no" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码"
                    :label-width="formLabelWidth"
                    prop="password"
                    :rules="[
                    { required: true, message: '请输入密码', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {CouponIndex, CouponAdd, CouponDel, CouponAddCarWash} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    type: 3,
                    searchSelect: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增优惠券",
                formLabelWidth: "140px",
                form: {
                    id: 0,
                    coupon_no: "",
                    password: "",
                },
                dialogWashFormVisible: false,
                washform: {
                  num: 1
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                console.log('洗车券', this.data)
                CouponIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addCarWash(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        CouponAddCarWash(this.washform).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogWashFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        CouponAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    coupon_no: data.coupon_no,
                    password: data.password,

                }
                this.dialogTitle = this.form.id > 0 ? "编辑洗车券" : "新增洗车券"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    coupon_no: "",
                    password: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增优惠券"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    CouponDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  // console.log(this.loginInfo.app_url+'/manage/coupon/excel?')
                  location.href = this.loginInfo.app_url+'/manage/coupon/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
                  console.log(this.loginInfo)
                  console.log('取消操作')
              });
            },
        }
    }
</script>

<style>
</style>
